/** Icons generated by create-react-icons. Don't edit this file directly. **/
import React from "react";
import PropTypes from "prop-types";

export function DataSources(props) {
  const { size, color, ...other } = props;
  return (
    <svg viewBox="0 0 24 24" fill="none" height={size} width={size} {...other}>
      <path
        d="M9 7H4"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 18H6C5.46957 18 4.96086 17.7893 4.58579 17.4142C4.21071 17.0391 4 16.5304 4 16V3"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.4393 3.614L14.614 2.43934C14.8953 2.15804 15.2768 2 15.6747 2H18.5C18.8978 2 19.2794 2.15804 19.5607 2.43934C19.842 2.72064 20 3.10218 20 3.5V8.5C20 8.89782 19.842 9.27936 19.5607 9.56066C19.2794 9.84196 18.8978 10 18.5 10H14.5C14.1022 10 13.7206 9.84196 13.4393 9.56066C13.158 9.27936 13 8.89782 13 8.5V4.67465C13 4.27683 13.158 3.8953 13.4393 3.614V3.614ZM13.4393 14.614L14.614 13.4393C14.8953 13.158 15.2768 13 15.6747 13H18.5C18.8978 13 19.2794 13.158 19.5607 13.4393C19.842 13.7206 20 14.1022 20 14.5V19.5C20 19.8978 19.842 20.2794 19.5607 20.5607C19.2794 20.842 18.8978 21 18.5 21H14.5C14.1022 21 13.7206 20.842 13.4393 20.5607C13.158 20.2794 13 19.8978 13 19.5V15.6747C13 15.2768 13.158 14.8953 13.4393 14.614V14.614Z"
        stroke={color}
        fillRule="evenodd"
        clipRule="evenodd"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

DataSources.defaultProps = {
  color: "currentColor",
  size: 24,
};

DataSources.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
